import React from 'react';

import AppContainer from '../AppContainer/AppContainer';
import AppTitle from '../AppTitle/AppTitle';
// import AppText from '../AppText/AppText';

import styles from './AppServiceInnerTitle.module.scss';

export default function AppServiceInnerTitle({ title, desc }) {

  return (
    <div className={styles.AppServiceInnerTitle}>
      <AppContainer>
        <div className={styles.AppServiceInnerTitle__Title}>
          <AppTitle>{title}</AppTitle>
        </div>
        <div className={styles.AppServiceInnerTitle__Desc}>
          <h3>{desc}</h3>
        </div>
      </AppContainer>
    </div>
  );
}
